import React from 'react';
import { useAppDispatch } from 'app';
import { loginUser } from '../authentication-slice';
import appLocalStorage from 'app/local-storage';
import { logoutUser } from 'components/authentication/components/authentication-slice';

export default function ValidateLogin({ token }: { token: string }) {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    appLocalStorage.remove();
    dispatch(logoutUser());
    localStorage.clear();
    dispatch(loginUser({ dealerId: '0', username: '', password: '', token: token })).then((response) => {
      let url = new URL(window.location.href);
      url.searchParams.delete('token');
      let u = url.toString();
      window.location.href = u;
    });
  }, []);

  return (
    <div style={{ margin: '20px' }}>
      <h2>Authorizing. Please Wait......</h2>
    </div>
  );
}
